import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    subtitle: {
      color: palette.sideGray,
      fontWeight: 500,
      fontSize: 12,
    },
    values: {
      marginLeft: 30,
      height: '100%',
      width: '100%',
    },
    filter: {
      paddingRight: 30,
      alignItems: 'center',
      marginTop: 5,
      height: '20%',

      '& .MuiButton-text': { marginLeft: '0px !important' },
    },
    titleCard: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 14,
      fontWeight: 500,
      zIndex: 2,
      margin: '10px 0px',
    },
    title: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 12,
      fontWeight: 500,
      zIndex: 2,
    },
    value: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 12,
      fontWeight: 500,
      zIndex: 2,
    },
    content: { margin: '7.5px 0px' },
  });

export const overrideCard = () => {
  const overrideStyles = {
    minHeight: 61,
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  };

  return overrideStyles;
};

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};
